import Loaders from './Loaders';

export default Loaders;
